import { ProgramWizardLookupsManager } from '../../services';
import { Flex } from '@chakra-ui/react';
import uniq from 'lodash/uniq';
import { Descriptions } from '@ssar-app/uikit';

const { Item } = Descriptions;

interface ProgramWizardInActiveWarningProps {
  lookupsManager: ProgramWizardLookupsManager;
}

interface WarningProps {
  name: string;
  disables: string[];
}

const Warning = (props: WarningProps) => {
  const commonStyles = {
    position: 'relative',
    transform: 'translateY(50%)',
    content: '""',
    borderBlockStart: '1px solid transparent',
    borderBlockStartColor: 'inherit',
    top: '50%',
  };
  return (
    <>
      <br></br>
      <Flex
        my={4}
        fontWeight='medium'
        fontSize='md'
        textAlign='center'
        whiteSpace='nowrap'
        borderBlockStart='0 rgba(5,5,5,.06)'
        _before={{ ...commonStyles, width: '5%' }}
        _after={{ ...commonStyles, width: '95%' }}
      >
        {props.name}
      </Flex>
      <Descriptions size='small' column={5}>
        {uniq(props.disables || []).map((a, index) => (
          <Item
            key={`${props.name}_${index}`}
            labelProps={{ width: '100%' }}
            contentProps={{ width: '100%' }}
          >
            {a}
          </Item>
        ))}
      </Descriptions>
    </>
  );
};

export const ProgramWizardInActiveWarning = (
  props: ProgramWizardInActiveWarningProps,
) => {
  const { lookupsManager } = props;
  return (
    <>
      {lookupsManager.doesDisabledScoresLookupsExist() && (
        <Warning
          name='Scores'
          disables={lookupsManager.getDisableScoresLookupsNames()}
        ></Warning>
      )}
      {lookupsManager.doesDisabledTrendviewsLookupsExist() && (
        <Warning
          name='Trendviews'
          disables={lookupsManager.getDisableTrendviewsLookupsNames()}
        ></Warning>
      )}
      {lookupsManager.doesDisabledAddonProductsLookupsExist() && (
        <Warning
          name='Add-On Products'
          disables={lookupsManager.getDisableAddonProductsLookupsNames()}
        ></Warning>
      )}
      {lookupsManager.doesDisabledDemographicsLookupsExist() && (
        <Warning
          name='Demographics'
          disables={lookupsManager.getDisableDemographicsLookupsNames()}
        ></Warning>
      )}
      {lookupsManager.doesDisabledBundlesLookupsExist() && (
        <Warning
          name='Bundles'
          disables={lookupsManager.getDisableBundlesLookupsNames()}
        ></Warning>
      )}
      {lookupsManager.doesDisabledAttributesLookupsExist() && (
        <Warning
          name='Attributes'
          disables={lookupsManager.getDisableAttributesLookupsNames()}
        ></Warning>
      )}
    </>
  );
};
